"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MockUserProfile = {
    id: 1,
    display_name: "Mock User",
    bio: "Mock User Bio",
    user: {
        username: "mock",
        email: "mock@twii.test",
        groups: [
            {
                name: "user"
            },
            {
                name: "developer"
            },
            {
                name: "admin"
            }
        ]
    }
};
var MockUserService = /** @class */ (function () {
    function MockUserService() {
    }
    Object.defineProperty(MockUserService.prototype, "userProfile", {
        get: function () {
            return this._userProfile || MockUserProfile;
        },
        set: function (value) {
            this._userProfile = value;
        },
        enumerable: true,
        configurable: true
    });
    MockUserService.prototype.getUsers = function (request) {
        return Promise.resolve([this.userProfile.user]);
    };
    MockUserService.prototype.getUserProfile = function () {
        return Promise.resolve(Object.assign({}, this.userProfile));
    };
    return MockUserService;
}());
exports.MockUserService = MockUserService;
